<template>
    <section>
        <TheHeader/>

        <div class=" pt-32 md:pt-12 lg:relative">
            <FAQs/>
        </div>
        <TheFooter/>
    </section>
</template>

<script>
import TheHeader from '../layout/TheHeader.vue';
import TheFooter from '../layout/TheFooter.vue';
import FAQs from './HomePage/FAQs.vue'
export default {
    components: {
        TheHeader,
        TheFooter,
        FAQs
    }
}
</script>